import { ApiConstants } from "../utils/ApiConstants";
import axios from "axios";

export default class CpgmuiService {
  public static submitServiceOperation(data: any) {
    return axios.post(ApiConstants.execServiceOperation, data);
  }
  public static submitServiceOperationRest(data: any) {
    return axios.post(ApiConstants.execServiceOperationRest, data);
  }
  public static submitCusac360b2bcarepakRest(data: any) {
    return axios.post(ApiConstants.cusac360b2bcarepak, data);
  }
  public static submitCusac360b2bsnrRest(data: any) {
    return axios.post(ApiConstants.cusac360b2bsnr, data);
  }
  public static submitS21csamycsachRest(data: any) {
    return axios.post(ApiConstants.s21csamycsach, data);
  }
}
